(() => {
  // 没有 URL 变体时，使用 Liquid 传入的第一个变体 ID。
  const defaultVariantId = document.currentScript?.dataset.defaultVariantId || '';

  // 根据当前 URL 变体，切换 section 的原生 hidden 属性。
  const updateVisibility = () => {
    const variantId = new URLSearchParams(window.location.search).get('variant') || defaultVariantId;

    document.querySelectorAll('*[data-visibility-ids]').forEach((section) => {
      const variantIds = (section.dataset.visibilityIds || '')
        .split(',')
        .map((id) => id.trim())
        .filter(Boolean);

      section.hidden = variantIds.length > 0 && !variantIds.includes(variantId);
    });
  };

  // 只监听 URL 变化，不监听其他变体事件。
  ['replaceState', 'pushState'].forEach((method) => {
    const original = window.history[method];
    window.history[method] = function (...args) {
      const result = original.apply(this, args);
      updateVisibility();
      return result;
    };
  });
  window.addEventListener('popstate', updateVisibility);
  updateVisibility();
})();
